<div class=" class-summary_sum_wrapper ">
    <fieldset class="class-summary-scheduler-border">
        <legend class="class-summary-report-scheduler-border">Search Criteria</legend>
        <div class="col-md-12">
            <form #ClassSummary="ngForm" (ngSubmit)="getSearch(1)" autocomplete="off">
                <div class="row">

                    <div class="col-sm-3 class-summary_sum_col">
                        <div class="form-group has-feedback ">
                            <label for="dateFrom" class="control-label">Date From:</label>

                            <div class="class-summary-input-group">
                                <input class="form-control" id="dateFrom" name="dateFrom" [(ngModel)]="DateFrom" ngbDatepicker #dateFrom="ngbDatepicker" style="cursor: pointer;" (click)="dateFrom.toggle()" [maxDate]="DateTo" readonly required>
                                <i (click)="dateFrom.toggle()" class="fa fa-calendar" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-3 class-summary_sum_col ">
                        <div class="form-group has-feedback">
                            <label for="DateTo" class="control-label">Date To:</label>

                            <div class="class-summary-input-group">
                                <input class="form-control" id="DateTo" name="DateTo" [(ngModel)]="DateTo" ngbDatepicker [maxDate]="maxDate" [minDate]="DateFrom" #dateTo="ngbDatepicker" style="cursor: pointer;" (click)="dateTo.toggle()" readonly required>
                                <i (click)="dateTo.toggle()" class="fa fa-calendar" aria-hidden="true"></i>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6 class-summary_sum_col">
                        <div class="form-group orders_sum_top class-summary_sum_top">
                            <div class="pull-right">
                                <button type="submit" class="btn btn-primary">Search</button>
                                <button type="button" class="btn btn-default" (click)="cancelSearch()">Clear</button>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>
    </fieldset>

    <fieldset class="class-summary-scheduler-border clearfix marign_10">
        <legend class="class-summary-report-scheduler-border">Class Summary Report</legend>




        <div class="class-summary-panel_tablepayment">
            <div class="panel panel-default ">
                <div class="table-responsive pull-left max-width margin-top-10">
                    <table class="table table-bordered table-striped">
                        <thead class="tableHeader">
                            <tr>
                                <th>Class</th>
                                <th>Category</th>
                                <th>Invoice</th>
                                <th>Items</th>
                                <th>Net(Without Taxes)</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="classSummaryResult">
                            <tr class="{{classSummaryObj.classCode}}" *ngFor="let classSummaryObj of classSummaryResult.classSummary; let i = index">
                                <td>{{classSummaryObj.classCode}}</td>
                                <td>{{classSummaryObj.Category}}</td>
                                <td style="text-align: right;">{{classSummaryObj.Invoice}}</td>
                                <td style="text-align: right;">{{classSummaryObj.Item}}</td>
                                <td style="text-align: right;">${{classSummaryObj.NetAmount}}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </fieldset>

</div>